import React from 'react';
import Icon from '../../components/AppIcon';
import { Link } from 'react-router-dom';
import TopNavigation from '../../components/TopNavigation';
import Footer from '../../components/Footer';

const MaritimeUseCaseDetail = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <TopNavigation />
      
      {/* Hero Section */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      
      {/* Left Column - Text Content */}
      <div>
        <div 
          className="inline-flex items-center gap-2 px-4 py-2 rounded-md text-xs font-semibold uppercase tracking-wider mb-6 w-fit"
          style={{ backgroundColor: '#4FB3B8', color: '#242423' }}
        >
          Maritime Operations
        </div>
        
        <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight" style={{ color: '#E8EDDF' }}>
          Predictive Fleet Operations Powered by Data
        </h1>
        
        <p className="text-base md:text-lg leading-relaxed mb-8" style={{ color: '#9CA3AF' }}>
          Real-time vessel data processing, AI-supported predictive maintenance, and secure edge-to-cloud connectivity—moving maritime operations from reactive to data-driven without compromising safety.
        </p>
        
        <div className="flex flex-wrap gap-4">
          <Link 
            to="/contact" 
            className="inline-flex items-center gap-2 px-8 py-4 rounded-lg font-semibold text-base transition-colors"
            style={{ backgroundColor: '#4FB3B8', color: '#242423' }}
          >
            Request a Platform Demo
          </Link>
          <Link 
            to="/use-cases" 
            className="inline-flex items-center gap-2 px-8 py-4 rounded-lg font-semibold text-base transition-colors"
            style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38', color: '#F5CB5C' }}
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
            </svg>
            Explore Other Use Cases
          </Link>
        </div>
      </div>
      
      {/* Right Column - Diagram */}
      <div className="flex items-center justify-center">
        <div 
          className="w-full rounded-xl p-6"
          style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
        >
          <svg width="100%" height="480" viewBox="0 0 400 480" className="max-w-full">
            
            {/* Centralized Cloud Hub */}
            <rect x="75" y="20" width="250" height="70" rx="6" fill="#242423" stroke="#4FB3B8" strokeWidth="2" />
            <text x="200" y="45" textAnchor="middle" fill="#E8EDDF" fontSize="12" fontWeight="700">CENTRALIZED CLOUD HUB</text>
            <text x="200" y="63" textAnchor="middle" fill="#9CA3AF" fontSize="9">Fleet Analytics • Predictive Models • Dashboards</text>
            <text x="200" y="78" textAnchor="middle" fill="#9CA3AF" fontSize="8">Sleeve Platform</text>
            
            {/* Connection lines from Cloud Hub to Vessels */}
            <line x1="140" y1="90" x2="80" y2="150" stroke="#9CA3AF" strokeWidth="1.5" />
            <line x1="200" y1="90" x2="200" y2="150" stroke="#9CA3AF" strokeWidth="1.5" />
            <line x1="260" y1="90" x2="320" y2="150" stroke="#9CA3AF" strokeWidth="1.5" />
            
            {/* Vessel 1 */}
            <g>
              <rect x="20" y="150" width="120" height="75" rx="4" fill="#242423" stroke="#4FB3B8" strokeWidth="1.5" />
              {/* Ship icon */}
              <g transform="translate(65, 165)">
                <path d="M0 15 L15 15 L20 25 L-5 25 Z" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
                <rect x="3" y="5" width="9" height="10" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
              </g>
              <text x="80" y="205" textAnchor="middle" fill="#4FB3B8" fontSize="10" fontWeight="600">VESSEL 1</text>
              <text x="80" y="218" textAnchor="middle" fill="#9CA3AF" fontSize="8">Atlantic Route</text>
            </g>
            
            {/* Vessel 1 Edge Node */}
            <circle cx="80" cy="250" r="6" fill="#4FB3B8" />
            <text x="80" y="270" textAnchor="middle" fill="#9CA3AF" fontSize="8">Edge Node</text>
            <line x1="80" y1="225" x2="80" y2="244" stroke="#9CA3AF" strokeWidth="1" />
            
            {/* Vessel 2 */}
            <g>
              <rect x="140" y="150" width="120" height="75" rx="4" fill="#242423" stroke="#4FB3B8" strokeWidth="1.5" />
              {/* Ship icon */}
              <g transform="translate(185, 165)">
                <path d="M0 15 L15 15 L20 25 L-5 25 Z" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
                <rect x="3" y="5" width="9" height="10" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
              </g>
              <text x="200" y="205" textAnchor="middle" fill="#4FB3B8" fontSize="10" fontWeight="600">VESSEL 2</text>
              <text x="200" y="218" textAnchor="middle" fill="#9CA3AF" fontSize="8">Pacific Route</text>
            </g>
            
            {/* Vessel 2 Edge Node */}
            <circle cx="200" cy="250" r="6" fill="#4FB3B8" />
            <text x="200" y="270" textAnchor="middle" fill="#9CA3AF" fontSize="8">Edge Node</text>
            <line x1="200" y1="225" x2="200" y2="244" stroke="#9CA3AF" strokeWidth="1" />
            
            {/* Vessel 3 */}
            <g>
              <rect x="260" y="150" width="120" height="75" rx="4" fill="#242423" stroke="#4FB3B8" strokeWidth="1.5" />
              {/* Ship icon */}
              <g transform="translate(305, 165)">
                <path d="M0 15 L15 15 L20 25 L-5 25 Z" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
                <rect x="3" y="5" width="9" height="10" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
              </g>
              <text x="320" y="205" textAnchor="middle" fill="#4FB3B8" fontSize="10" fontWeight="600">VESSEL 3</text>
              <text x="320" y="218" textAnchor="middle" fill="#9CA3AF" fontSize="8">Mediterranean</text>
            </g>
            
            {/* Vessel 3 Edge Node */}
            <circle cx="320" cy="250" r="6" fill="#4FB3B8" />
            <text x="320" y="270" textAnchor="middle" fill="#9CA3AF" fontSize="8">Edge Node</text>
            <line x1="320" y1="225" x2="320" y2="244" stroke="#9CA3AF" strokeWidth="1" />
            
            {/* Connection lines from Edge Nodes to Data Processing */}
            {/* Left diagonal */}
            <path d="M80 256 L80 290 Q80 310 100 320 L140 340" stroke="#F5CB5C" strokeWidth="1.5" fill="none" />
            <text x="90" y="305" fill="#9CA3AF" fontSize="7" transform="rotate(-45, 90, 305)">Telemetry</text>
            
            {/* Middle line */}
            <line x1="200" y1="256" x2="200" y2="330" stroke="#F5CB5C" strokeWidth="1.5" />
            <text x="215" y="300" fill="#9CA3AF" fontSize="7">Sensor Data</text>
            
            {/* Right diagonal */}
            <path d="M320 256 L320 290 Q320 310 300 320 L260 340" stroke="#F5CB5C" strokeWidth="1.5" fill="none" />
            <text x="295" y="305" fill="#9CA3AF" fontSize="7" transform="rotate(45, 295, 305)">Diagnostics</text>
            
            {/* Data Processing Pipeline */}
            <rect x="75" y="330" width="250" height="60" rx="6" fill="#242423" stroke="#F5CB5C" strokeWidth="2" />
            <text x="200" y="355" textAnchor="middle" fill="#E8EDDF" fontSize="11" fontWeight="700">DATA PROCESSING PIPELINE</text>
            <text x="200" y="370" textAnchor="middle" fill="#9CA3AF" fontSize="8">Sleeve Actions: ML/AI • Math Models • Custom Logic</text>
            <text x="200" y="382" textAnchor="middle" fill="#9CA3AF" fontSize="8">Generate actionable insights from raw vessel data</text>
            
            {/* Connection to OPS */}
            <line x1="200" y1="390" x2="200" y2="420" stroke="#F5CB5C" strokeWidth="1.5" />
            
            {/* OPS Circle */}
            <circle cx="200" cy="440" r="22" fill="#242423" stroke="#F5CB5C" strokeWidth="2" strokeDasharray="4 2" />
            <text x="200" y="445" textAnchor="middle" fill="#F5CB5C" fontSize="10" fontWeight="600">OPS</text>
            <text x="200" y="475" textAnchor="middle" fill="#9CA3AF" fontSize="9">Fleet Operators</text>
            
          </svg>
        </div>
      </div>
      
    </div>
  </div>
</section>

      {/* The Data-to-Action Backbone */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Header */}
    <div className="text-center mb-12">
      <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
        The Data-to-Action Backbone
      </h2>
      <p className="text-base md:text-lg max-w-3xl mx-auto" style={{ color: '#9CA3AF' }}>
        Sleeve transforms raw vessel data into processed insights that drive automated responses or human-approved actions across the entire fleet.
      </p>
    </div>
    
    {/* Diagram Card */}
    <div 
      className="rounded-xl p-8 md:p-12 mb-12"
      style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
    >
      <svg width="100%" height="320" viewBox="0 0 900 320" className="max-w-full">
        
        {/* SENSORS Box */}
        <rect x="20" y="80" width="140" height="120" rx="6" fill="#242423" stroke="#F5CB5C" strokeWidth="2" />
        <text x="90" y="110" textAnchor="middle" fill="#E8EDDF" fontSize="12" fontWeight="700">SENSORS</text>
        <text x="90" y="135" textAnchor="middle" fill="#9CA3AF" fontSize="10">Temperature</text>
        <text x="90" y="155" textAnchor="middle" fill="#9CA3AF" fontSize="10">Vibration</text>
        <text x="90" y="175" textAnchor="middle" fill="#9CA3AF" fontSize="10">Pressure</text>
        <text x="90" y="220" textAnchor="middle" fill="#9CA3AF" fontSize="9">Onboard Sensors</text>
        
        {/* Arrow: Sensors → Edge Node */}
        <line x1="160" y1="140" x2="220" y2="140" stroke="#9CA3AF" strokeWidth="1.5" />
        <polygon points="220,140 212,136 212,144" fill="#9CA3AF" />
        <text x="190" y="130" textAnchor="middle" fill="#9CA3AF" fontSize="8">Raw Data</text>
        
        {/* EDGE NODE Box */}
        <rect x="230" y="80" width="140" height="120" rx="6" fill="#242423" stroke="#4FB3B8" strokeWidth="2" />
        <text x="300" y="110" textAnchor="middle" fill="#E8EDDF" fontSize="12" fontWeight="700">EDGE NODE</text>
        <text x="300" y="135" textAnchor="middle" fill="#9CA3AF" fontSize="10">Pre-processing</text>
        <text x="300" y="155" textAnchor="middle" fill="#9CA3AF" fontSize="10">Filtering</text>
        <text x="300" y="175" textAnchor="middle" fill="#9CA3AF" fontSize="10">Edge Compute</text>
        <text x="300" y="220" textAnchor="middle" fill="#9CA3AF" fontSize="9">Vessel Edge</text>
        
        {/* Arrow: Edge Node → Sleeve Action */}
        <line x1="370" y1="140" x2="430" y2="140" stroke="#9CA3AF" strokeWidth="1.5" />
        <polygon points="430,140 422,136 422,144" fill="#9CA3AF" />
        <text x="400" y="130" textAnchor="middle" fill="#9CA3AF" fontSize="8">Processed</text>
        
        {/* SLEEVE ACTION Box (larger) */}
        <rect x="440" y="60" width="180" height="160" rx="6" fill="#242423" stroke="#4FB3B8" strokeWidth="2" />
        <text x="530" y="90" textAnchor="middle" fill="#E8EDDF" fontSize="12" fontWeight="700">SLEEVE ACTION</text>
        
        {/* Inner boxes for ML/AI, Math, Custom Logic */}
        <rect x="460" y="105" width="140" height="28" rx="4" fill="#242423" stroke="#3A3A38" strokeWidth="1" />
        <text x="530" y="124" textAnchor="middle" fill="#9CA3AF" fontSize="10">ML / AI Models</text>
        
        <rect x="460" y="140" width="140" height="28" rx="4" fill="#242423" stroke="#3A3A38" strokeWidth="1" />
        <text x="530" y="159" textAnchor="middle" fill="#9CA3AF" fontSize="10">Math Models</text>
        
        <rect x="460" y="175" width="140" height="28" rx="4" fill="#242423" stroke="#3A3A38" strokeWidth="1" />
        <text x="530" y="194" textAnchor="middle" fill="#9CA3AF" fontSize="10">Custom Logic</text>
        
        <text x="530" y="245" textAnchor="middle" fill="#9CA3AF" fontSize="9">Cloud Processing</text>
        
        {/* Arrow: Sleeve Action → Dashboards */}
        <line x1="620" y1="140" x2="680" y2="140" stroke="#9CA3AF" strokeWidth="1.5" />
        <polygon points="680,140 672,136 672,144" fill="#9CA3AF" />
        <text x="650" y="130" textAnchor="middle" fill="#9CA3AF" fontSize="8">Insights</text>
        
        {/* DASHBOARDS Box */}
        <rect x="690" y="80" width="140" height="120" rx="6" fill="#242423" stroke="#F5CB5C" strokeWidth="2" />
        <text x="760" y="110" textAnchor="middle" fill="#E8EDDF" fontSize="12" fontWeight="700">DASHBOARDS</text>
        <text x="760" y="135" textAnchor="middle" fill="#9CA3AF" fontSize="10">Live View</text>
        <text x="760" y="155" textAnchor="middle" fill="#9CA3AF" fontSize="10">Alerts</text>
        <text x="760" y="175" textAnchor="middle" fill="#9CA3AF" fontSize="10">Automation</text>
        <text x="760" y="220" textAnchor="middle" fill="#9CA3AF" fontSize="9">Fleet Operations</text>
        
      </svg>
    </div>
    
    {/* Three Column Descriptions */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      
      {/* Raw Data Collection */}
      <div>
        <h3 className="text-lg font-bold mb-3" style={{ color: '#E8EDDF' }}>
          Raw Data Collection
        </h3>
        <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
          Sensors across propulsion systems, cargo holds, and navigation equipment continuously stream data to edge nodes installed onboard.
        </p>
      </div>
      
      {/* Intelligent Processing */}
      <div>
        <h3 className="text-lg font-bold mb-3" style={{ color: '#E8EDDF' }}>
          Intelligent Processing
        </h3>
        <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
          Sleeve Actions apply ML models, deterministic algorithms, and custom logic to generate actionable insights—anomaly detection, trend analysis, predictive alerts.
        </p>
      </div>
      
      {/* Centralized Visibility */}
      <div>
        <h3 className="text-lg font-bold mb-3" style={{ color: '#E8EDDF' }}>
          Centralized Visibility
        </h3>
        <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
          Fleet operators access live dashboards showing entire fleet status, historical trends, and automated responses—all from a single platform.
        </p>
      </div>
      
    </div>
    
  </div>
</section>

      {/* Fleet Dashboards & Automation */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Header */}
    <div className="text-center mb-12">
      <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
        Fleet Dashboards & Automation
      </h2>
      <p className="text-base md:text-lg max-w-3xl mx-auto" style={{ color: '#9CA3AF' }}>
        Operators interact with data through live views, historical analysis, threshold alerts, and automated triggers.
      </p>
    </div>
    
    {/* 2x2 Grid */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      
      {/* Live Data View */}
      <div 
        className="rounded-xl p-6"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex items-center gap-3 mb-4">
          <div 
            className="w-10 h-10 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: 'rgba(79, 179, 184, 0.15)' }}
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
            </svg>
          </div>
          <h3 className="text-xl font-bold" style={{ color: '#E8EDDF' }}>Live Data View</h3>
        </div>
        
        <p className="text-sm leading-relaxed mb-6" style={{ color: '#9CA3AF' }}>
          Real-time telemetry from all vessels displayed in unified dashboards. Monitor engine performance, fuel consumption, environmental conditions, and system health across the entire fleet simultaneously.
        </p>
        
        {/* Chart Header */}
        <div className="flex items-center justify-between mb-3">
          <span className="text-xs" style={{ color: '#9CA3AF' }}>Engine Temp (°C)</span>
          <span className="text-xs font-semibold" style={{ color: '#4FB3B8' }}>LIVE</span>
        </div>
        
        {/* Bar Chart */}
        <div className="flex items-end gap-1.5 h-16 mb-2">
          <div className="flex-1 rounded-sm" style={{ height: '70%', backgroundColor: '#4FB3B8' }}></div>
          <div className="flex-1 rounded-sm" style={{ height: '65%', backgroundColor: '#4FB3B8' }}></div>
          <div className="flex-1 rounded-sm" style={{ height: '75%', backgroundColor: '#4FB3B8' }}></div>
          <div className="flex-1 rounded-sm" style={{ height: '60%', backgroundColor: '#4FB3B8' }}></div>
          <div className="flex-1 rounded-sm" style={{ height: '80%', backgroundColor: '#4FB3B8' }}></div>
          <div className="flex-1 rounded-sm" style={{ height: '85%', backgroundColor: '#3A8A8E' }}></div>
          <div className="flex-1 rounded-sm" style={{ height: '90%', backgroundColor: '#2D6B6E' }}></div>
          <div className="flex-1 rounded-sm" style={{ height: '95%', backgroundColor: '#2D6B6E' }}></div>
          <div className="flex-1 rounded-sm" style={{ height: '85%', backgroundColor: '#3A8A8E' }}></div>
          <div className="flex-1 rounded-sm" style={{ height: '75%', backgroundColor: '#4FB3B8' }}></div>
          <div className="flex-1 rounded-sm" style={{ height: '70%', backgroundColor: '#4FB3B8' }}></div>
          <div className="flex-1 rounded-sm" style={{ height: '80%', backgroundColor: '#4FB3B8' }}></div>
        </div>
        
        <div className="text-right">
          <span className="text-xs" style={{ color: '#9CA3AF' }}>Last 12 hours</span>
        </div>
      </div>
      
      {/* Recorded Data */}
      <div 
        className="rounded-xl p-6"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex items-center gap-3 mb-4">
          <div 
            className="w-10 h-10 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: 'rgba(245, 203, 92, 0.15)' }}
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
              <rect x="3" y="3" width="18" height="6" rx="1" />
              <rect x="3" y="12" width="18" height="6" rx="1" />
            </svg>
          </div>
          <h3 className="text-xl font-bold" style={{ color: '#F5CB5C' }}>Recorded Data</h3>
        </div>
        
        <p className="text-sm leading-relaxed mb-6" style={{ color: '#9CA3AF' }}>
          Access historical vessel data for trend analysis, regulatory compliance, and performance optimization. Query specific time ranges, compare vessels, and export datasets for offline analysis.
        </p>
        
        {/* Chart Header */}
        <div className="flex items-center justify-between mb-3">
          <span className="text-xs" style={{ color: '#9CA3AF' }}>Fuel Efficiency</span>
          <span className="text-xs font-semibold" style={{ color: '#F5CB5C' }}>7 DAYS</span>
        </div>
        
        {/* Line Chart */}
        <div className="h-16 mb-2 relative">
          <svg width="100%" height="100%" viewBox="0 0 300 60" preserveAspectRatio="none">
            <path 
              d="M0 50 Q50 48 75 45 T150 35 T225 20 T300 10" 
              fill="none" 
              stroke="#F5CB5C" 
              strokeWidth="2"
            />
            <circle cx="300" cy="10" r="4" fill="#F5CB5C" />
          </svg>
        </div>
        
        <div className="text-right">
          <span className="text-xs" style={{ color: '#9CA3AF' }}>Improving trend</span>
        </div>
      </div>
      
      {/* Threshold-Based Alerts */}
      <div 
        className="rounded-xl p-6"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex items-center gap-3 mb-4">
          <div 
            className="w-10 h-10 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: 'rgba(255, 107, 107, 0.15)' }}
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#FF6B6B" strokeWidth="2">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </div>
          <h3 className="text-xl font-bold" style={{ color: '#E8EDDF' }}>Threshold-Based Alerts</h3>
        </div>
        
        <p className="text-sm leading-relaxed mb-6" style={{ color: '#9CA3AF' }}>
          Configure thresholds for critical parameters. Automatic alerts trigger when values exceed safe operating ranges, enabling rapid response before failures occur.
        </p>
        
        {/* Status Bars */}
        <div className="space-y-2">
          {/* Normal Status */}
          <div 
            className="flex items-center justify-between px-4 py-3 rounded-lg"
            style={{ backgroundColor: '#242423' }}
          >
            <div className="flex items-center gap-3">
              <span className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: '#4FB3B8' }}></span>
              <span className="text-sm" style={{ color: '#9CA3AF' }}>Pressure: Normal</span>
            </div>
            <span className="text-sm font-mono" style={{ color: '#9CA3AF' }}>2.1 bar</span>
          </div>
          
          {/* Warning Status */}
          <div 
            className="flex items-center justify-between px-4 py-3 rounded-lg"
            style={{ backgroundColor: 'rgba(255, 107, 107, 0.2)', border: '1px solid rgba(255, 107, 107, 0.4)' }}
          >
            <div className="flex items-center gap-3">
              <span className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: '#FF6B6B' }}></span>
              <span className="text-sm" style={{ color: '#E8EDDF' }}>Vibration: Warning</span>
            </div>
            <span className="text-sm font-mono" style={{ color: '#FF6B6B' }}>8.2 Hz</span>
          </div>
        </div>
      </div>
      
      {/* Automated Triggers */}
      <div 
        className="rounded-xl p-6"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex items-center gap-3 mb-4">
          <div 
            className="w-10 h-10 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: 'rgba(245, 203, 92, 0.15)' }}
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
              <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
            </svg>
          </div>
          <h3 className="text-xl font-bold" style={{ color: '#F5CB5C' }}>Automated Triggers</h3>
        </div>
        
        <p className="text-sm leading-relaxed mb-6" style={{ color: '#9CA3AF' }}>
          Define automated responses to specific conditions—notifications to engineering teams, activation of backup systems, or initiation of diagnostic routines without manual intervention.
        </p>
        
        {/* Rule Box */}
        <div 
          className="px-4 py-3 rounded-lg"
          style={{ backgroundColor: '#242423' }}
        >
          <div className="flex items-center gap-2 mb-2">
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm font-semibold" style={{ color: '#E8EDDF' }}>Rule Active</span>
          </div>
          <p className="text-xs font-mono" style={{ color: '#9CA3AF' }}>
            IF vibration &gt; 8.0 Hz → Notify maintenance team + Log diagnostic data
          </p>
        </div>
      </div>
      
    </div>
    
  </div>
</section>
      {/* From Reactive Repairs to Predictive Confidence */}
     <section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Header */}
    <div className="text-center mb-12">
      <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
        From Reactive Repairs to Predictive Confidence
      </h2>
      <p className="text-base md:text-lg max-w-3xl mx-auto" style={{ color: '#9CA3AF' }}>
        Unplanned downtime is extremely costly in maritime operations. Sleeve enables predictive maintenance through continuous data analysis and early warning systems.
      </p>
    </div>
    
    {/* Comparison Cards */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
      
      {/* Traditional Reactive Approach */}
      <div 
        className="rounded-xl p-6"
        style={{ backgroundColor: '#2E2E2C', border: '2px dashed #FF6B6B' }}
      >
        <h3 className="text-xl font-bold mb-5" style={{ color: '#E8EDDF' }}>
          Traditional Reactive Approach
        </h3>
        
        <ul className="space-y-4">
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#FF6B6B" strokeWidth="2">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Equipment fails before maintenance scheduled</span>
          </li>
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#FF6B6B" strokeWidth="2">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Unplanned downtime disrupts operations</span>
          </li>
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#FF6B6B" strokeWidth="2">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Remote access lacks predictive context</span>
          </li>
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#FF6B6B" strokeWidth="2">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Higher repair costs and vessel downtime</span>
          </li>
        </ul>
      </div>
      
      {/* Sleeve Predictive Approach */}
      <div 
        className="rounded-xl p-6"
        style={{ backgroundColor: '#2E2E2C', border: '2px dashed #4FB3B8' }}
      >
        <h3 className="text-xl font-bold mb-5" style={{ color: '#E8EDDF' }}>
          Sleeve Predictive Approach
        </h3>
        
        <ul className="space-y-4">
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>AI agents analyze continuous data streams</span>
          </li>
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Predict anomalies and component degradation</span>
          </li>
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Generate early warnings before failure</span>
          </li>
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Schedule maintenance during planned downtime</span>
          </li>
        </ul>
      </div>
      
    </div>
    
    {/* Predictive Maintenance Workflow Card */}
    <div 
      className="rounded-xl p-8"
      style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
    >
      <h3 className="text-xl md:text-2xl font-bold text-center mb-10" style={{ color: '#E8EDDF' }}>
        Predictive Maintenance Workflow
      </h3>
      
      {/* 4-Step Process */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        
        {/* Step 1: Detection */}
        <div className="flex flex-col items-center text-center">
          <div 
            className="w-14 h-14 rounded-full flex items-center justify-center mb-4"
            style={{ border: '2px solid #4FB3B8' }}
          >
            <span className="text-lg font-bold" style={{ color: '#4FB3B8' }}>1</span>
          </div>
          <h4 className="text-base font-semibold mb-2" style={{ color: '#E8EDDF' }}>Detection</h4>
          <p className="text-xs leading-relaxed" style={{ color: '#9CA3AF' }}>
            AI detects anomaly in vibration pattern indicating potential bearing wear
          </p>
        </div>
        
        {/* Step 2: Prediction */}
        <div className="flex flex-col items-center text-center">
          <div 
            className="w-14 h-14 rounded-full flex items-center justify-center mb-4"
            style={{ border: '2px solid #4FB3B8' }}
          >
            <span className="text-lg font-bold" style={{ color: '#4FB3B8' }}>2</span>
          </div>
          <h4 className="text-base font-semibold mb-2" style={{ color: '#E8EDDF' }}>Prediction</h4>
          <p className="text-xs leading-relaxed" style={{ color: '#9CA3AF' }}>
            Model predicts component failure within 7-10 days based on degradation trend
          </p>
        </div>
        
        {/* Step 3: Human Approval */}
        <div className="flex flex-col items-center text-center">
          <div 
            className="w-14 h-14 rounded-full flex items-center justify-center mb-4"
            style={{ border: '2px solid #F5CB5C' }}
          >
            <span className="text-lg font-bold" style={{ color: '#F5CB5C' }}>3</span>
          </div>
          <h4 className="text-base font-semibold mb-2" style={{ color: '#E8EDDF' }}>Human Approval</h4>
          <p className="text-xs leading-relaxed" style={{ color: '#9CA3AF' }}>
            Maintenance team reviews prediction, approves replacement during next port call
          </p>
        </div>
        
        {/* Step 4: Automated Action */}
        <div className="flex flex-col items-center text-center">
          <div 
            className="w-14 h-14 rounded-full flex items-center justify-center mb-4"
            style={{ border: '2px solid #F5CB5C' }}
          >
            <span className="text-lg font-bold" style={{ color: '#F5CB5C' }}>4</span>
          </div>
          <h4 className="text-base font-semibold mb-2" style={{ color: '#E8EDDF' }}>Automated Action</h4>
          <p className="text-xs leading-relaxed" style={{ color: '#9CA3AF' }}>
            Parts ordered, work scheduled, diagnostic logs prepared—no unplanned downtime
          </p>
        </div>
        
      </div>
      
      {/* Human-in-the-Loop Banner */}
      <div 
        className="rounded-lg px-6 py-4 text-center"
        style={{ backgroundColor: '#242423' }}
      >
        <p className="text-sm" style={{ color: '#9CA3AF' }}>
          <span className="font-semibold" style={{ color: '#E8EDDF' }}>Human-in-the-Loop Emphasis:</span>{' '}
          AI detects and recommends → Humans approve critical actions → Automated execution follows approval
        </p>
      </div>
      
    </div>
    
  </div>
</section>



      {/* Key Platform Capabilities */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Header */}
    <div className="text-center mb-12">
      <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
        Key Platform Capabilities
      </h2>
      <p className="text-base md:text-lg" style={{ color: '#9CA3AF' }}>
        Enterprise-grade features for maritime fleet operations.
      </p>
    </div>
    
    {/* Stacked Rows */}
    <div className="space-y-4">
      
      {/* Over-the-Air (OTA) Updates */}
      <div 
        className="rounded-xl p-6 flex items-center justify-between gap-6"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex-1">
          <h3 className="text-base font-bold mb-2" style={{ color: '#E8EDDF' }}>
            Over-the-Air (OTA) Updates
          </h3>
          <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
            Secure software patching and configuration updates deployed to vessels at sea. Version-controlled rollouts with automatic rollback capability.
          </p>
        </div>
        <div 
          className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
          style={{ backgroundColor: 'rgba(245, 203, 92, 0.15)' }}
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
            <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
          </svg>
        </div>
      </div>
      
      {/* Digital Twin Replication */}
      <div 
        className="rounded-xl p-6 flex items-center justify-between gap-6"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex-1">
          <h3 className="text-base font-bold mb-2" style={{ color: '#E8EDDF' }}>
            Digital Twin Replication
          </h3>
          <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
            Cloud or edge-based simulation of vessel systems for testing, training, and scenario analysis without physical vessel access.
          </p>
        </div>
        <div 
          className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
          style={{ backgroundColor: 'rgba(245, 203, 92, 0.15)' }}
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
          </svg>
        </div>
      </div>
      
      {/* Centralized Fleet Hub */}
      <div 
        className="rounded-xl p-6 flex items-center justify-between gap-6"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex-1">
          <h3 className="text-base font-bold mb-2" style={{ color: '#E8EDDF' }}>
            Centralized Fleet Hub
          </h3>
          <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
            Single control plane per customer providing unified visibility, access control, and orchestration across all vessels in the fleet.
          </p>
        </div>
        <div 
          className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
          style={{ backgroundColor: 'rgba(156, 163, 175, 0.15)' }}
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="16" y1="13" x2="8" y2="13" />
            <line x1="16" y1="17" x2="8" y2="17" />
          </svg>
        </div>
      </div>
      
      {/* Subscription-Based Model */}
      <div 
        className="rounded-xl p-6 flex items-center justify-between gap-6"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex-1">
          <h3 className="text-base font-bold mb-2" style={{ color: '#E8EDDF' }}>
            Subscription-Based Model
          </h3>
          <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
            Future-proof deployment with subscription licensing. Scale capacity as fleet grows, no large upfront capital expenditure.
          </p>
        </div>
        <div 
          className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
          style={{ backgroundColor: 'rgba(156, 163, 175, 0.15)' }}
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2">
            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
            <polyline points="17 6 23 6 23 12" />
          </svg>
        </div>
      </div>
      
      {/* Cross-Industry Leverage */}
      <div 
        className="rounded-xl p-6 flex items-center justify-between gap-6"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex-1">
          <h3 className="text-base font-bold mb-2" style={{ color: '#E8EDDF' }}>
            Cross-Industry Leverage
          </h3>
          <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
            Automotive-grade reliability and testing rigor applied to maritime operations. Proven in high-stakes SDV development environments.
          </p>
        </div>
        <div 
          className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
          style={{ backgroundColor: 'rgba(156, 163, 175, 0.15)' }}
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </div>
      </div>
      
    </div>
    
  </div>
</section>

      {/* Security Embedded in Operations */}

<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Header */}
    <div className="text-center mb-16">
      <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
        Security Embedded in Operations
      </h2>
      <p className="text-base md:text-lg max-w-3xl mx-auto" style={{ color: '#9CA3AF' }}>
        Security is not bolted on—it's embedded directly in data flow, action execution, and access control.
      </p>
    </div>
    
    {/* Two Column Layout - 70/30 split, diagram on left */}
    <div className="grid grid-cols-1 lg:grid-cols-10 gap-8 lg:gap-12">
      
      {/* Left Column - Diagram (70%) */}
      <div 
        className="lg:col-span-7 rounded-xl p-6"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <svg width="100%" height="520" viewBox="0 0 720 520" className="max-w-full">
          
          {/* Cloud Governance Box */}
          <rect x="185" y="20" width="350" height="100" rx="8" fill="#242423" stroke="#4FB3B8" strokeWidth="2" />
          
          {/* Shield icon */}
          <g transform="translate(215, 45)">
            <path d="M12 2 L4 6 v6 c0 5.5 3.4 10.6 8 12 4.6-1.4 8-6.5 8-12 V6 l-8-4z" fill="none" stroke="#4FB3B8" strokeWidth="2" />
          </g>
          
          <text x="390" y="55" textAnchor="middle" fill="#E8EDDF" fontSize="14" fontWeight="700">CLOUD GOVERNANCE</text>
          <text x="390" y="75" textAnchor="middle" fill="#9CA3AF" fontSize="10">Access Control • Key Management • Policy Enforcement</text>
          
          {/* Zero Trust + Real-Time Auth */}
          <g transform="translate(280, 90)">
            <rect x="0" y="0" width="12" height="9" rx="2" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
            <path d="M2 0 V-2 a4 4 0 0 1 8 0 V0" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
          </g>
          <text x="310" y="100" fill="#4FB3B8" fontSize="10">Zero Trust</text>
          
          <g transform="translate(380, 88)">
            <path d="M6 0 L0 8 h5 l-1 5 6-8 h-5 l1-5z" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
          </g>
          <text x="415" y="100" fill="#9CA3AF" fontSize="10">Real-Time Auth</text>
          
          {/* Dashed lines from Cloud to TLS badges */}
          <line x1="280" y1="120" x2="150" y2="170" stroke="#9CA3AF" strokeWidth="1.5" strokeDasharray="5 3" />
          <line x1="360" y1="120" x2="360" y2="170" stroke="#9CA3AF" strokeWidth="1.5" strokeDasharray="5 3" />
          <line x1="440" y1="120" x2="570" y2="170" stroke="#9CA3AF" strokeWidth="1.5" strokeDasharray="5 3" />
          
          {/* TLS 1.3 Badges */}
          <rect x="90" y="170" width="120" height="36" rx="18" fill="#4FB3B8" />
          <text x="150" y="194" textAnchor="middle" fill="#242423" fontSize="13" fontWeight="600">TLS 1.3</text>
          
          <rect x="300" y="170" width="120" height="36" rx="18" fill="#4FB3B8" />
          <text x="360" y="194" textAnchor="middle" fill="#242423" fontSize="13" fontWeight="600">TLS 1.3</text>
          
          <rect x="510" y="170" width="120" height="36" rx="18" fill="#4FB3B8" />
          <text x="570" y="194" textAnchor="middle" fill="#242423" fontSize="13" fontWeight="600">TLS 1.3</text>
          
          {/* Dashed lines from TLS to teal dots */}
          <line x1="150" y1="206" x2="150" y2="230" stroke="#9CA3AF" strokeWidth="1.5" strokeDasharray="5 3" />
          <line x1="360" y1="206" x2="360" y2="230" stroke="#9CA3AF" strokeWidth="1.5" strokeDasharray="5 3" />
          <line x1="570" y1="206" x2="570" y2="230" stroke="#9CA3AF" strokeWidth="1.5" strokeDasharray="5 3" />
          
          {/* Small teal dots above vessels */}
          <circle cx="150" cy="238" r="6" fill="#4FB3B8" />
          <circle cx="360" cy="238" r="6" fill="#4FB3B8" />
          <circle cx="570" cy="238" r="6" fill="#4FB3B8" />
          
          {/* Vessel A */}
          <g>
            <rect x="30" y="250" width="210" height="220" rx="8" fill="#242423" stroke="#3A3A38" strokeWidth="1.5" />
            
            {/* Shield badge - top right corner overlapping */}
            <circle cx="225" cy="260" r="18" fill="#4FB3B8" />
            <path d="M225 250 L218 254 v5 c0 4 2.5 7.5 7 8.5 4.5-1 7-4.5 7-8.5 v-5 l-7-4z" fill="#242423" />
            
            {/* Ship icon */}
            <g transform="translate(55, 270)">
              <path d="M5 20 L18 20 L22 28 L1 28 Z" fill="none" stroke="#9CA3AF" strokeWidth="1.5" />
              <rect x="5" y="8" width="13" height="12" fill="none" stroke="#9CA3AF" strokeWidth="1.5" />
              <rect x="9" y="3" width="5" height="5" fill="none" stroke="#9CA3AF" strokeWidth="1.5" />
            </g>
            
            {/* Status dot */}
            <circle cx="200" cy="290" r="5" fill="#4FB3B8" />
            
            <text x="55" y="325" fill="#E8EDDF" fontSize="14" fontWeight="700">VESSEL A</text>
            <text x="55" y="343" fill="#9CA3AF" fontSize="11">Atlantic Ocean</text>
            
            {/* Isolated Context Box */}
            <rect x="45" y="358" width="180" height="80" rx="6" fill="transparent" stroke="#4FB3B8" strokeWidth="1.5" />
            
            {/* Lock icon + ISOLATED CONTEXT */}
            <g transform="translate(57, 373)">
              <rect x="0" y="0" width="10" height="8" rx="1" fill="none" stroke="#4FB3B8" strokeWidth="1.2" />
              <path d="M2 0 V-2 a3 3 0 0 1 6 0 V0" fill="none" stroke="#4FB3B8" strokeWidth="1.2" />
            </g>
            <text x="77" y="381" fill="#4FB3B8" fontSize="11" fontWeight="600">ISOLATED CONTEXT</text>
            
            <circle cx="57" cy="400" r="3" fill="#4FB3B8" />
            <text x="68" y="404" fill="#9CA3AF" fontSize="10">Unique Credentials</text>
            
            <circle cx="57" cy="416" r="3" fill="#4FB3B8" />
            <text x="68" y="420" fill="#9CA3AF" fontSize="10">Edge Encrypted</text>
            
            <circle cx="57" cy="432" r="3" fill="#4FB3B8" />
            <text x="68" y="436" fill="#9CA3AF" fontSize="10">Audit Logged</text>
            
            {/* Secure */}
            <circle cx="90" cy="458" r="12" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
            <path d="M84 458 L88 462 L96 454" fill="none" stroke="#4FB3B8" strokeWidth="2" />
            <text x="110" y="463" fill="#4FB3B8" fontSize="12" fontWeight="600">SECURE</text>
          </g>
          
          {/* Vessel B */}
          <g>
            <rect x="255" y="250" width="210" height="220" rx="8" fill="#242423" stroke="#3A3A38" strokeWidth="1.5" />
            
            {/* Shield badge */}
            <circle cx="450" cy="260" r="18" fill="#4FB3B8" />
            <path d="M450 250 L443 254 v5 c0 4 2.5 7.5 7 8.5 4.5-1 7-4.5 7-8.5 v-5 l-7-4z" fill="#242423" />
            
            {/* Ship icon */}
            <g transform="translate(280, 270)">
              <path d="M5 20 L18 20 L22 28 L1 28 Z" fill="none" stroke="#9CA3AF" strokeWidth="1.5" />
              <rect x="5" y="8" width="13" height="12" fill="none" stroke="#9CA3AF" strokeWidth="1.5" />
              <rect x="9" y="3" width="5" height="5" fill="none" stroke="#9CA3AF" strokeWidth="1.5" />
            </g>
            
            {/* Status dot */}
            <circle cx="425" cy="290" r="5" fill="#4FB3B8" />
            
            <text x="280" y="325" fill="#E8EDDF" fontSize="14" fontWeight="700">VESSEL B</text>
            <text x="280" y="343" fill="#9CA3AF" fontSize="11">Pacific Ocean</text>
            
            {/* Isolated Context Box */}
            <rect x="270" y="358" width="180" height="80" rx="6" fill="transparent" stroke="#4FB3B8" strokeWidth="1.5" />
            
            <g transform="translate(282, 373)">
              <rect x="0" y="0" width="10" height="8" rx="1" fill="none" stroke="#4FB3B8" strokeWidth="1.2" />
              <path d="M2 0 V-2 a3 3 0 0 1 6 0 V0" fill="none" stroke="#4FB3B8" strokeWidth="1.2" />
            </g>
            <text x="302" y="381" fill="#4FB3B8" fontSize="11" fontWeight="600">ISOLATED CONTEXT</text>
            
            <circle cx="282" cy="400" r="3" fill="#4FB3B8" />
            <text x="293" y="404" fill="#9CA3AF" fontSize="10">Unique Credentials</text>
            
            <circle cx="282" cy="416" r="3" fill="#4FB3B8" />
            <text x="293" y="420" fill="#9CA3AF" fontSize="10">Edge Encrypted</text>
            
            <circle cx="282" cy="432" r="3" fill="#4FB3B8" />
            <text x="293" y="436" fill="#9CA3AF" fontSize="10">Audit Logged</text>
            
            <circle cx="315" cy="458" r="12" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
            <path d="M309 458 L313 462 L321 454" fill="none" stroke="#4FB3B8" strokeWidth="2" />
            <text x="335" y="463" fill="#4FB3B8" fontSize="12" fontWeight="600">SECURE</text>
          </g>
          
          {/* Vessel C */}
          <g>
            <rect x="480" y="250" width="210" height="220" rx="8" fill="#242423" stroke="#3A3A38" strokeWidth="1.5" />
            
            {/* Shield badge */}
            <circle cx="675" cy="260" r="18" fill="#4FB3B8" />
            <path d="M675 250 L668 254 v5 c0 4 2.5 7.5 7 8.5 4.5-1 7-4.5 7-8.5 v-5 l-7-4z" fill="#242423" />
            
            {/* Ship icon */}
            <g transform="translate(505, 270)">
              <path d="M5 20 L18 20 L22 28 L1 28 Z" fill="none" stroke="#9CA3AF" strokeWidth="1.5" />
              <rect x="5" y="8" width="13" height="12" fill="none" stroke="#9CA3AF" strokeWidth="1.5" />
              <rect x="9" y="3" width="5" height="5" fill="none" stroke="#9CA3AF" strokeWidth="1.5" />
            </g>
            
            {/* Status dot */}
            <circle cx="650" cy="290" r="5" fill="#4FB3B8" />
            
            <text x="505" y="325" fill="#E8EDDF" fontSize="14" fontWeight="700">VESSEL C</text>
            <text x="505" y="343" fill="#9CA3AF" fontSize="11">Indian Ocean</text>
            
            {/* Isolated Context Box */}
            <rect x="495" y="358" width="180" height="80" rx="6" fill="transparent" stroke="#4FB3B8" strokeWidth="1.5" />
            
            <g transform="translate(507, 373)">
              <rect x="0" y="0" width="10" height="8" rx="1" fill="none" stroke="#4FB3B8" strokeWidth="1.2" />
              <path d="M2 0 V-2 a3 3 0 0 1 6 0 V0" fill="none" stroke="#4FB3B8" strokeWidth="1.2" />
            </g>
            <text x="527" y="381" fill="#4FB3B8" fontSize="11" fontWeight="600">ISOLATED CONTEXT</text>
            
            <circle cx="507" cy="400" r="3" fill="#4FB3B8" />
            <text x="518" y="404" fill="#9CA3AF" fontSize="10">Unique Credentials</text>
            
            <circle cx="507" cy="416" r="3" fill="#4FB3B8" />
            <text x="518" y="420" fill="#9CA3AF" fontSize="10">Edge Encrypted</text>
            
            <circle cx="507" cy="432" r="3" fill="#4FB3B8" />
            <text x="518" y="436" fill="#9CA3AF" fontSize="10">Audit Logged</text>
            
            <circle cx="540" cy="458" r="12" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
            <path d="M534 458 L538 462 L546 454" fill="none" stroke="#4FB3B8" strokeWidth="2" />
            <text x="560" y="463" fill="#4FB3B8" fontSize="12" fontWeight="600">SECURE</text>
          </g>
          
          {/* Bottom Row */}
          <g transform="translate(130, 485)">
            <path d="M10 2 L4 5 v5 c0 4 2.5 7.8 6 9 3.5-1.2 6-5 6-9 V5 l-6-3z" fill="none" stroke="#9CA3AF" strokeWidth="1.5" />
          </g>
          <text x="165" y="500" fill="#E8EDDF" fontSize="11" fontWeight="600">Zero-Trust Architecture</text>
          
          <circle cx="295" cy="495" r="3" fill="#9CA3AF" />
          
          <g transform="translate(320, 485)">
            <rect x="0" y="4" width="12" height="10" rx="2" fill="none" stroke="#9CA3AF" strokeWidth="1.5" />
            <path d="M2 4 V1 a4 4 0 0 1 8 0 V4" fill="none" stroke="#9CA3AF" strokeWidth="1.5" />
          </g>
          <text x="355" y="500" fill="#E8EDDF" fontSize="11" fontWeight="600">Per-Vessel Credentials</text>
          
          <circle cx="485" cy="495" r="3" fill="#9CA3AF" />
          
          <g transform="translate(510, 483)">
            <path d="M12 2 H5 a2 2 0 0 0 -2 2 v12a2 2 0 0 0 2 2 h10a2 2 0 0 0 2-2 V6 z" fill="none" stroke="#9CA3AF" strokeWidth="1.5" />
            <path d="M12 2 V6 H17" fill="none" stroke="#9CA3AF" strokeWidth="1.5" />
          </g>
          <text x="550" y="500" fill="#E8EDDF" fontSize="11" fontWeight="600">Complete Audit Trail</text>
          
        </svg>
      </div>
      
      {/* Right Column - Text Content (30%) */}
      <div className="lg:col-span-3">
        <h3 className="text-2xl md:text-3xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
          Per-Delivery Security Configuration
        </h3>
        
        <p className="text-sm leading-relaxed mb-8" style={{ color: '#9CA3AF' }}>
          Each vessel deployment receives unique credentials, access policies, and encryption keys. Zero-trust architecture ensures compromised vessels don't affect fleet-wide security.
        </p>
        
        {/* Security Features List */}
        <div className="space-y-6">
          
          {/* Encrypted Data Streams */}
          <div className="flex items-start gap-4">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
            <div>
              <h4 className="text-sm font-bold mb-1" style={{ color: '#E8EDDF' }}>Encrypted Data Streams</h4>
              <p className="text-sm" style={{ color: '#9CA3AF' }}>TLS 1.3 for all vessel-to-cloud communication</p>
            </div>
          </div>
          
          {/* Role-Based Access Control */}
          <div className="flex items-start gap-4">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
            <div>
              <h4 className="text-sm font-bold mb-1" style={{ color: '#E8EDDF' }}>Role-Based Access Control</h4>
              <p className="text-sm" style={{ color: '#9CA3AF' }}>Granular permissions per user and vessel</p>
            </div>
          </div>
          
          {/* Audit Logging */}
          <div className="flex items-start gap-4">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
            <div>
              <h4 className="text-sm font-bold mb-1" style={{ color: '#E8EDDF' }}>Audit Logging</h4>
              <p className="text-sm" style={{ color: '#9CA3AF' }}>Complete access and action history for compliance</p>
            </div>
          </div>
          
        </div>
      </div>
      
    </div>
    
  </div>
</section>


      {/* Industry Validation */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Header */}
    <div className="text-center mb-12">
      <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
        Industry Validation
      </h2>
      <p className="text-base md:text-lg" style={{ color: '#9CA3AF' }}>
        Proven in real maritime deployments and industry-recognized innovation programs.
      </p>
    </div>
    
    {/* Two Cards */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
      
      {/* Industry Recognition Card */}
      <div 
        className="rounded-xl p-8"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        {/* Header row with icon and label */}
        <div className="flex items-start gap-4 mb-4">
          <div 
            className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: 'rgba(79, 179, 184, 0.15)' }}
          >
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
          <div>
            <span className="text-xs font-bold tracking-wider" style={{ color: '#4FB3B8' }}>INDUSTRY RECOGNITION</span>
            <h3 className="text-2xl font-bold mt-1" style={{ color: '#E8EDDF' }}>
              EIT BoostUp Challenge Winner
            </h3>
          </div>
        </div>
        
        <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
          Selected as winner in the European Institute of Innovation and Technology's BoostUp Challenge for maritime innovation. Recognized for edge-to-cloud architecture and predictive maintenance capabilities.
        </p>
      </div>
      
      {/* Proof of Concept Card */}
      <div 
        className="rounded-xl p-8"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        {/* Header row with icon and label */}
        <div className="flex items-start gap-4 mb-4">
          <div 
            className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: 'rgba(245, 203, 92, 0.15)' }}
          >
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
            </svg>
          </div>
          <div>
            <span className="text-xs font-bold tracking-wider" style={{ color: '#F5CB5C' }}>PROOF OF CONCEPT</span>
            <h3 className="text-2xl font-bold mt-1" style={{ color: '#E8EDDF' }}>
              Berg Propulsion Deployment
            </h3>
          </div>
        </div>
        
        <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
          Deployed Sleeve for secure remote connectivity and monitoring across real vessels and lab environments. Validated edge data processing, secure cloud integration, and predictive analytics capabilities.
        </p>
      </div>
      
    </div>
    
    {/* Bottom Stats Bar */}
    <div 
      className="rounded-xl py-8 px-6"
      style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
        
        {/* Real Vessels */}
        <div>
          <h4 className="text-xl md:text-2xl font-bold mb-1" style={{ color: '#4FB3B8' }}>Real Vessels</h4>
          <p className="text-sm" style={{ color: '#9CA3AF' }}>Operational deployments</p>
        </div>
        
        {/* Real Labs */}
        <div>
          <h4 className="text-xl md:text-2xl font-bold mb-1" style={{ color: '#F5CB5C' }}>Real Labs</h4>
          <p className="text-sm" style={{ color: '#9CA3AF' }}>Test environment validation</p>
        </div>
        
        {/* Secure Connectivity */}
        <div>
          <h4 className="text-xl md:text-2xl font-bold mb-1" style={{ color: '#4FB3B8' }}>Secure Connectivity</h4>
          <p className="text-sm" style={{ color: '#9CA3AF' }}>Proven edge-to-cloud architecture</p>
        </div>
        
      </div>
    </div>
    
  </div>
</section>

      {/* Final CTA Section */}
      <section className="py-24 md:py-32 px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-2xl font-bold text-foreground mb-6">
            Request a Maritime Demo
          </h2>
          
          <div className="flex flex-wrap justify-center gap-4 mb-8">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Icon name="TrendingDown" size={16} color="var(--color-success)" />
              <span>Reduced downtime</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Icon name="TrendingUp" size={16} color="var(--color-success)" />
              <span>Higher fleet availability</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Icon name="Shield" size={16} color="var(--color-success)" />
              <span>Safer operations</span>
            </div>
          </div>
          
          <div className="flex flex-wrap justify-center gap-4">
            <Link 
              to="/contact" 
              className="inline-flex items-center gap-2 px-8 py-4 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary/90 transition-colors text-lg"
            >
              Request a Maritime Demo
              <Icon name="ArrowRight" size={20} />
            </Link>
            <Link 
              to="/manufacturing-use-case-detail" 
              className="inline-flex items-center gap-2 px-8 py-4 bg-card border border-border text-foreground rounded-lg font-medium hover:bg-card/80 transition-colors text-lg"
            >
              View Manufacturing Use Case
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MaritimeUseCaseDetail;